export const cameras = {
	es: {
		general: {
			title: "Cámaras",
			tabs: ["Eventos", "Manual"],
			filter: ["Buscar un dispositivo", "Selecciona un dispositivo"],
			dates: ["Seleccionar días", "Fechas disponibles"],
			start: "Consultar",
			all: "Seleccionar todos",
			search: "Buscar...",
			progress: "Tu archivo se esta descargando",
			delete: "Eliminar recurso",
		},
		wakeUp: {
			title: "Despertar cámaras",
			loadingMsg: "Este proceso puede tardar unos segundos",
			wakeUpBtn: "Despertar",
		},
		events: {
			status: ["En línea", "Desconectado"],
			details: [
				{ label: "Dispositivos", width: "" },
				{ label: "Estado", width: "10%" },
				{ label: "Fecha", width: "12%" },
				{ label: "Total Consumido", width: "10%" },
				{ label: "Total Disponible", width: "10%" },
				{ label: "Total ", width: "10%" },
				{ label: "Alarmas", width: "12%" },
			],
			modal: [
				{ label: "ID Alarma", width: "10%" },
				{ label: "Inicio", width: "10%" },
				{ label: "Coordenadas", width: "28%" },
				{ label: "Dirección", width: "" },
				{ label: "Video", width: "10%" },
				// { label: 'Imagen', width: '10%' },
			],
		},
		videos: {
			title: "Archivos disponibles",
			nodates: "Sin fechas disponibles",
			calendar: {
				file: {
					camera: "Cámara",
					front: "Frontal",
					operator: "Operador",
					video: "Video",
					capture: "Captura",
				},
				form: {
					title: "Descarga",
					subtitle: "Parciales",
					action: "Descargar",
					nopartials: "Sin descargas parciales",
					start: {
						label: "Hora de inicio",
						placeholder: "00:00:00",
					},
					quality: {
						label: "Calidad",
						placeholder: ["Low", "High"],
						options: [
							["Baja", "low"],
							["Alta", "high"],
						],
					},
					interval: {
						label: "Duración",
						placeholder: "",
						suffix: "sec",
					},
					end: {
						label: "Hora fin",
						placeholder: "00:00:00",
					},
				},
			},
			columns: [
				{ label: "Inicio", width: "" },
				{ label: "Fin", width: "" },
				{ label: "Duración", width: "" },
				{ label: "Archivo", width: "" },
			],
		},
		live: {
			title: ["Cámaras en vivo"],
			labels: [
				"Nombre de la cámara",
				"Cámara frontal",
				"Cámara conductor",
				"Inicializando el live",
				"Deteniendo el live",
				"Cambiando al lente frontal",
				"Cambiando al lente de conductor",
				"Buscar dispositivo",
			],
			errors: [
				"Selecciona primero un dispositivo",
				"Algo salió mal, intente nuevamente",
				"La cámara está apagada",
				"Limite de datos alcanzado",
			],
		},
		history: {
			title: [
				"Descargas de eventos",
				"Descargas manuales",
				"Descargas activas",
				"Despertar cámaras",
			],
			noactives: "Sin descargas",
			timezone: "UTC (Zona Horaria)",
			columns: [
				{ label: "Fecha", tab: ["events", "actives"], width: "14%" },
				{ label: "Inicio", tab: ["manual"], width: "" },
				{ label: "Fin", tab: ["manual"], width: "" },
				{
					label: "Dispositivo",
					tab: ["events", "manual", "actives"],
					width: "",
				},
				{ label: "Alarma", tab: ["events", "actives"], width: "8%" },
				{
					label: "Cámara",
					tab: ["events", "manual", "actives"],
					width: "8%",
				},
				{
					label: "Archivo",
					tab: ["events", "manual", "actives"],
					width: "8%",
				},
				{ label: "Duración", tab: ["manual"], width: "10%" },
				{ label: "Coordenadas", tab: ["events"], width: "28%" },
				{
					label: "Estatus",
					tab: ["events", "manual", "actives"],
					width: "10%",
				},
			],
		},
		storage: {
			title: "Almacenamiento",
			current: "Actual",
			total: "Total",
			device: "Dispositivo",
		},
		notifications: {
			error: "Error de consulta, intente de nuevo",
			camaraAwake: "La cámara ha despertado",
			nodata: "No hay datos para la consulta",
			noparams: [
				"Debe seleccionar al menos un dispositivo y/o el rango de fechas",
				"Debe seleccionar un dispositivo y/o la fecha",
				"La cámara esta apagada",
				"No se obtuvo respuesta de la cámara",
			],
			files: {
				success: [
					"Archivo solicitado con ID {id}, ya se puede descargar",
					"Recurso ha sido descargado",
				],
				error: [
					"Por el momento no se puede generar el recurso, intente mas tarde",
					"El video solicitado no se puede encontrar en la memoria de la cámara",
					"Archivo solicitado con ID {id} no se encuentra disponible en la cámara",
					"El video ya no está disponible en la cámara",
					"Ha alcanzado el límite máximo de almacenamiento",
					"El video solicitado puede estar dañado, por lo tanto no podrá realizar la conversion",
				],
				general: [
					"Se esta cargando la información, espere un momento por favor",
					"Por el momento no se puede solicitar el recurso porque la cámara esta fuera de línea.",
					"Espere un momento, su recurso esta siendo procesado.",
					"La cámara ya tiene una descarga activa",
					"El recurso se esta descargando en segundo plano",
				],
				delete: [
					"El recurso del evento fue eliminado",
					"El recurso fue eliminado",
				],
			},
		},
		alarms: {
			0: "Pérdida de Vídeo",
			1: "Lente Tapado",
			3: "Fallo de Almacenamiento",
			7: "Alarma de Pánico",
			8: "Exceso de Velocidad",
			9: "Bajo Voltaje",
			18: "Alarma ACC",
			38: "Fallo de Alimentación",
			18006: "Aceleración brusca",
			18007: "Freno Brusco",
			18010: "Giro Brusco a la Izquierda",
			18011: "Giro Brusco a la Derecha",
			18015: "Shock",
			40001: "IO1",
			40002: "IO2",
			40003: "IO3",
			40004: "IO4",
			56000: "Fatiga del Conductor",
			56001: "Sin Conductor",
			56002: "Llamada telefónica",
			56003: "Conductor Fumando",
			56004: "Conductor Distraído",
			56005: "Aviso de Salida de Carril LDW",
			56006: "Aviso de Colisión Frontal FCW",
			56009: "Cercanía de vehículo HMW",
			56010: "Bostezo",
			56011: "Aviso de Colisión con Peatones PCW",
			56016: "Sin Cinturón de Seguridad",
			56025: "Violación de Señal de Stop",
			56031: "Violación de Señal de Límite de Velocidad",
		},
	},
	en: {
		general: {
			title: "Cameras",
			tabs: ["Events", "Manual"],
			filter: ["Search a device", "Select a device"],
			dates: ["Select days", "Available days"],
			start: "Start",
			all: "Select all",
			search: "Search...",
			progress: "Your file is downloading",
			delete: "Delete resource",
		},
		wakeUp: {
			title: "Wake up cameras",
			loadingMsg: "This process may takes a few seconds",
			wakeUpBtn: "Wake up",
		},
		events: {
			status: ["Online", "Offline"],
			details: [
				{ label: "Devices", width: "" },
				{ label: "Status", width: "8%" },
				{ label: "Date", width: "12%" },
				{ label: "Total Consumed", width: "10%" },
				{ label: "Total Available", width: "10%" },
				{ label: "Total ", width: "10%" },
				{ label: "Alarms", width: "12%" },
			],
			modal: [
				{ label: "Alarm ID", width: "10%" },
				{ label: "Start", width: "10%" },
				{ label: "Coordinates", width: "28%" },
				{ label: "Address", width: "" },
				{ label: "Video", width: "10%" },
				// { label: 'Image', width: '10%' },
			],
		},
		videos: {
			title: "Available files",
			nodates: "Without dates availables",
			calendar: {
				file: {
					camera: "Camera",
					front: "Front",
					operator: "Operator",
					video: "Video",
					capture: "Capture",
				},
				form: {
					title: "Download",
					subtitle: "Partials",
					action: "Download",
					nopartials: "No partial downloads ",
					start: {
						label: "Start time",
						placeholder: "00:00:00",
					},
					quality: {
						label: "Quality",
						placeholder: ["Low", "High"],
						options: [
							["Low", "low"],
							["High", "high"],
						],
					},
					interval: {
						label: "Duration",
						placeholder: "",
						suffix: "sec",
					},
					end: {
						label: "End time",
						placeholder: "00:00:00",
					},
				},
			},
			columns: [
				{ label: "Start", width: "" },
				{ label: "End", width: "" },
				{ label: "Duration", width: "" },
				{ label: "File", width: "" },
			],
		},
		live: {
			title: ["Live cameras"],
			labels: [
				"Camera's name",
				"Front camera",
				"Driver camera",
				"Initializing the live",
				"Stopping the live",
				"Switching to front lens",
				"Switching to driver's lens",
				"Find device",
			],
			errors: [
				"Choose a device first",
				"Something went wrong, try again",
				"The camera is off",
				"Data limit reached",
			],
		},
		history: {
			title: [
				"Event downloads",
				"Manual downloads",
				"Active downloads",
				"Awake cameras",
			],
			noactives: "No downloads",
			timezone: "UTC (Time Zone)",
			columns: [
				{ label: "Date", tab: ["events", "actives"], width: "20%" },
				{ label: "Start", tab: ["manual"], width: "" },
				{ label: "End", tab: ["manual"], width: "" },
				{
					label: "Device",
					tab: ["events", "manual", "actives"],
					width: "",
				},
				{ label: "Alarm", tab: ["events", "actives"], width: "12%" },
				{
					label: "Camera",
					tab: ["events", "manual", "actives"],
					width: "12%",
				},
				{
					label: "File",
					tab: ["events", "manual", "actives"],
					width: "12%",
				},
				{ label: "Duration", tab: ["manual"], width: "" },
				{ label: "Coordinates", tab: ["events"], width: "" },
				{
					label: "Status",
					tab: ["events", "manual", "actives"],
					width: "14%",
				},
			],
		},
		storage: {
			title: "Storage",
			current: "Current",
			total: "Total",
			device: "Device",
		},
		notifications: {
			error: "Query failure, try again",
			nodata: "No data for the query",
			camaraAwake: "The camera has woken up",
			noparams: [
				"You must select at least one device and/or the date range",
				"You must select one device and/or the date",
				"The camera is offline",
				"The camera did not answer",
			],
			files: {
				success: [
					"Requested file with ID {id}, can now be downloaded",
					"The resource has been downloaded",
				],
				error: [
					"At the moment the resource cannot be generated, try again later",
					"The requested video cannot be found on the camera's memory",
					"Requested file with ID {id} is not available on the camera",
					"The video is no longer available on the camera",
					"You have reached the maximum storage limit",
					"The requested video may be corrupted, therefore you will not be able to convert",
				],
				general: [
					"The information is being loaded, wait a moment please",
					"At the moment the resource cannot be requested because the camera is offline.",
					"Wait a moment, your resource is being processed.",
					"The camera already has an active download",
					"The resource is downloading in the background",
				],
				delete: [
					"The event resource was deleted",
					"The resource was deleted",
				],
			},
		},
		alarms: {
			0: "Video Loss",
			1: "Lens Covered",
			3: "Storage Malfunction",
			7: "Panic Alarm",
			8: "Over Speed",
			9: "Low Voltage",
			18: "ACC Alarm",
			38: "Power failure alarm",
			18006: "Hard Acceleration",
			18007: "Harsh Brake",
			18010: "Harsh Left Turn",
			18011: "Harsh Right Turn",
			18015: "Shock",
			40001: "IO1",
			40002: "IO2",
			40003: "IO3",
			40004: "IO4",
			56000: "Driver Fatigue",
			56001: "No Driver",
			56002: "Phone Calling",
			56003: "Driver Smoking",
			56004: "Driver Distracted",
			56005: "Lane departure warning LDW",
			56006: "Forward Collision Warning FCW",
			56009: "Headway Monitoring HMW",
			56010: "Yawn",
			56011: "Pedestrian Collision Warning PCW",
			56016: "Not wearing seatbelt",
			56025: "Stop sign violation alarm",
			56031: "Speed limit sign violation alarm",
		},
	},
};
